import { createTheme, responsiveFontSizes } from '@mui/material/styles';

let theme = createTheme({
  palette: {
    primary: {
      main: "#CD6F32", // brand color
    },
    secondary: {
      main: '#292E34', 
    },
    background: {
      default: '#FAFAFA',
      paper: '#FFFFFF',
    },
    text: {
      primary: '#292E34',
      secondary: '#B07156',
    },
  },
  typography: {
    fontFamily: 'Poppins, Roboto, sans-serif',
    h1: {
      fontWeight: 700,
      fontSize: '3rem',
      lineHeight: 1.3,
    },
    h2: {
      fontWeight: 600,
      fontSize: '2.4rem',
      lineHeight: 1.3,
    },
    h3: {
      fontWeight: 500,
      fontSize: '1.8rem',
      lineHeight: 1.3,
    },
    h4: {
      fontWeight: 500,
      fontSize: '1.6rem',
    },
    // etc.
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: '8px',
          textTransform: 'none',
          fontWeight: 600,
          padding: '0.6rem 1.6rem',
        },
      },
    },
    MuiCssBaseline: {
      styleOverrides: {
        ".bubble": {
          backgroundColor: '#292E34',
          boxShadow: '0 0 10px #CD6F32',
        },
        ".understand-box": {
          backgroundColor: '#CD6F32',
        },
      },
    },
  },
});

// Make typography responsive across breakpoints
theme = responsiveFontSizes(theme);

export default theme;
